import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppInformationService, ArkUnitOfWork, UtilityService } from 'app/core/core.module';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import { alert } from 'devextreme/ui/dialog';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FamiliesInfosDetailComponent } from '../families-detail/families-detail.component';

@Component({
    selector: 'app-picture-directory',
    templateUrl: './picture-directory.component.html',
    styleUrls: ['./picture-directory.component.scss'],
    imports: [CommonModule, DevExtremeModule],
    standalone: true,
})
export class PictureDirectoryComponent implements OnInit {
    people: any[];
    pictures: any;
    familyStatuses: any;
    households = [
        { id: 1, name: 'Household #1' },
        { id: 2, name: 'Household #2' },
        { id: 3, name: 'Household #3' },
        { id: 4, name: 'Household #4' },
        { id: 5, name: 'Household #5' },
        { id: 6, name: 'Household #6' },
        { id: 7, name: 'Household #7' },
        { id: 8, name: 'Household #8' },
    ];
    selectedHouseholdId: number;
    states: any[];
    families: any[];
    isReady = false;
    searchValue: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(private appInfo: AppInformationService, private utility: UtilityService, private uow: ArkUnitOfWork, private modalService: BsModalService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const families = await this.uow.getFamiliesInfos();
        this.pictures = await this.uow.getFamiliesPhotos();
        for (let index = 0; index < families.length; index++) {
            const family = families[index];
            family.photoUrl = await this.getPhotos(family.id);
        }
        this.families = families.filter((x) => x.photoUrl !== null);
        this.appInfo.pleaseWaitHide();
        this.isReady = true;
    }

    async onSearch(e) {
        await this.getData();
        if (!!this.searchValue)
            this.families = this.families.filter((x) => {
                if (x.name.toLowerCase().indexOf(this.searchValue) > -1) return x;
            });
        if (!!this.selectedHouseholdId)
            this.families = this.families.filter((x) => {
                if (x.householdId === this.selectedHouseholdId) return x;
            });
    }

    private async getPhotos(familyId: number): Promise<string> {
        const promise = new Promise<string>(async (resolve) => {
            let photoUrl = null;
            const photo: any = _(this.pictures).find((p) => p.familyId === familyId);
            // const photo = (await this.uow.photos.where(predicate)) as any;
            if (!!photo) {
                // console.log(photo);
                photoUrl = this.utility.getPhoto(photo.fileName, 0, 150);
            }
            resolve(photoUrl);
        });

        return promise;
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'before',
            }
        );
    }

    setFocusedRowKey(key) {
        this.dataGrid.selectedRowKeys = [];
        this.dataGrid.focusedRowKey = key;
        sessionStorage.setItem(this.dataGrid.stateStoring.storageKey, JSON.stringify(this.dataGrid.instance.state()));
    }

    selectedViewChanged() {
        this.getData();
    }

    async openFamily(data: any) {
        const modalRef = this.modalService.show(FamiliesInfosDetailComponent, {
            class: 'modal-lgw',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                familyId: data.id,
                showAsDialog: true,
                photoUrl: data.photoUrl
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            }
            modalRef.hide();
        });
    }
}
